function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_6083",
  "data-name": "Group 6083",
  transform: "translate(-720 -106.332)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6081",
  "data-name": "Group 6081"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6076",
  "data-name": "Group 6076"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3423",
  "data-name": "Path 3423",
  d: "M0,0,24.72,17.673",
  transform: "matrix(-0.259, 0.966, -0.966, -0.259, 884.313, 241.117)",
  fill: "none",
  stroke: "#f37320",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3424",
  "data-name": "Path 3424",
  d: "M11239.455,20190.123l-32.883,26.961v42.055h66.4v-41.1Z",
  transform: "translate(-10345.728 -19946.404)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_id_848418",
  transform: "translate(875.226 266.275)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3440",
  "data-name": "Path 3440",
  d: "M26.386,8.585h-2.1a4.086,4.086,0,0,0-7.934,0h-2.1a.97.97,0,0,0-.97.97v7.612a.97.97,0,0,0,.97.97H26.386a.97.97,0,0,0,.97-.97V9.559a.97.97,0,0,0-.97-.974Zm-.97,7.612h-10.2V10.525h1.994a.97.97,0,0,0,.97-.97,2.146,2.146,0,1,1,4.287,0,.97.97,0,0,0,.97.97h1.983Zm13.719,1.443V36.358a3.678,3.678,0,0,1-3.686,3.674H5.186A3.678,3.678,0,0,1,1.5,36.358V17.641a3.678,3.678,0,0,1,3.686-3.674h5.529a.97.97,0,0,1,0,1.94H5.186A1.734,1.734,0,0,0,3.44,17.641V36.358a1.734,1.734,0,0,0,1.746,1.734H35.449a1.734,1.734,0,0,0,1.734-1.734V17.641a1.734,1.734,0,0,0-1.734-1.734H29.921a.97.97,0,0,1,0-1.94h5.529a3.678,3.678,0,0,1,3.686,3.674ZM13.869,28.032a3.686,3.686,0,1,0-3.732-3.686A3.686,3.686,0,0,0,13.869,28.032Zm0-5.432a1.746,1.746,0,1,1-1.793,1.746A1.769,1.769,0,0,1,13.869,22.6Zm4.508,11.52V32.234a1.436,1.436,0,0,0-1.455-1.412h-.462l-1.645,1.63a1.354,1.354,0,0,1-1.87,0l-1.664-1.63H10.8a1.436,1.436,0,0,0-1.455,1.412v1.886a.97.97,0,0,1-1.94,0V32.234A3.379,3.379,0,0,1,10.8,28.881h.877a.97.97,0,0,1,.679.279l1.513,1.486,1.513-1.486a.97.97,0,0,1,.663-.279h.877a3.379,3.379,0,0,1,3.391,3.352v1.886a.97.97,0,0,1-1.94,0Zm16.055-11.4a.97.97,0,0,1-.97.97H21.047a.97.97,0,1,1,0-1.94H33.463a.97.97,0,0,1,.97.97Zm0,4.268a.97.97,0,0,1-.97.97H23.647a.97.97,0,1,1,0-1.94h9.816a.97.97,0,0,1,.97,1Zm0,4.268a.97.97,0,0,1-.97.97H23.647a.97.97,0,1,1,0-1.94h9.816a.97.97,0,0,1,.97,1Z",
  transform: "translate(-1.5 -5.476)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5372",
  "data-name": "Rectangle 5372",
  width: 5.485,
  height: 5.485,
  transform: "translate(818.025 275.482)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5373",
  "data-name": "Rectangle 5373",
  width: 6.856,
  height: 5.485,
  transform: "translate(828.995 275.482)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5374",
  "data-name": "Rectangle 5374",
  width: 6.856,
  height: 5.485,
  transform: "translate(841.337 275.482)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3442",
  "data-name": "Path 3442",
  d: "M60.889,146.133A18.284,18.284,0,0,0,42.9,161.355h-.274a30.444,30.444,0,0,1,0-60.889h3.318a18.245,18.245,0,0,0,35.985,0h30.992a18.245,18.245,0,0,0,35.985,0h3.318a36.533,36.533,0,1,0,0-73.067h-24.63a18.245,18.245,0,0,0-35.985,0H66.978V3.044A3.044,3.044,0,0,0,63.933,0H3.044A3.044,3.044,0,0,0,0,3.044V51.755A3.044,3.044,0,0,0,3.044,54.8H63.933a3.044,3.044,0,0,0,3.044-3.044V33.489h24.63a18.245,18.245,0,0,0,35.985,0h24.63a30.444,30.444,0,1,1,0,60.889H148.9a18.245,18.245,0,0,0-35.985,0H81.926a18.245,18.245,0,0,0-35.985,0H42.622a36.533,36.533,0,1,0,0,73.067H42.9a18.245,18.245,0,0,0,35.985,0h6.363v-6.089H78.881A18.284,18.284,0,0,0,60.889,146.133ZM30.444,6.089h6.089V18.267H30.444ZM60.889,48.711H6.089V6.089H24.356V21.311A3.044,3.044,0,0,0,27.4,24.356H39.578a3.044,3.044,0,0,0,3.044-3.044V6.089H60.889ZM109.6,42.622a12.178,12.178,0,1,1,12.178-12.178A12.19,12.19,0,0,1,109.6,42.622Zm21.311,42.622a12.178,12.178,0,1,1-12.178,12.178A12.19,12.19,0,0,1,130.911,85.244Zm-66.978,0A12.178,12.178,0,1,1,51.755,97.422,12.19,12.19,0,0,1,63.933,85.244Zm-3.044,91.333A12.178,12.178,0,1,1,73.067,164.4,12.19,12.19,0,0,1,60.889,176.578Z",
  transform: "translate(726.148 113.67)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_263",
  "data-name": "Ellipse 263",
  cx: 8.913,
  cy: 8.913,
  r: 8.913,
  transform: "translate(781 202.49)",
  fill: "#f37320"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5375",
  "data-name": "Rectangle 5375",
  width: 74.714,
  height: 76.027,
  transform: "translate(720 106.332)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_6080",
  "data-name": "Group 6080",
  transform: "translate(129.163 -381.354)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 29,
  height: 29,
  transform: "translate(636.837 519.354)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_6082",
  "data-name": "Group 6082"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_5417",
  "data-name": "Rectangle 5417",
  transform: "translate(610.837 491.354)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 65,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 53,
  height: 62,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3490",
  "data-name": "Path 3490",
  d: "M9693.379,17711.166h42.139",
  transform: "translate(-9076.015 -17208.357)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3491",
  "data-name": "Path 3491",
  d: "M9693.379,17711.166h42.139",
  transform: "translate(-9076.015 -17201.414)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3492",
  "data-name": "Path 3492",
  d: "M9693.379,17711.166h21.07",
  transform: "translate(-9076.015 -17188.16)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3493",
  "data-name": "Path 3493",
  d: "M9693.379,17711.166h21.07",
  transform: "translate(-9076.015 -17181.219)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3494",
  "data-name": "Path 3494",
  d: "M9693.379,17711.166h21.07",
  transform: "translate(-9076.015 -17174.275)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3495",
  "data-name": "Path 3495",
  d: "M9693.379,17711.166h21.07",
  transform: "translate(-9076.015 -17166.406)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M-705.613,13.824l-6.295-6.287V25.066a.912.912,0,0,1-.912.912h-.005a.912.912,0,0,1-.911-.912V7.537l-6.295,6.287a.911.911,0,0,1-1.289,0h0a.912.912,0,0,1,0-1.289l7.852-7.852a.915.915,0,0,1,1.293,0l7.852,7.852a.912.912,0,0,1,0,1.289h0A.911.911,0,0,1-705.613,13.824Z",
  transform: "translate(1363.769 519.145)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3496",
  "data-name": "Path 3496",
  d: "M9693.379,17711.166h42.139",
  transform: "translate(-9076.015 -17194.471)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2.5
}))));

function SvgStepper4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.741,
    height: 208.902,
    viewBox: "0 0 209.741 208.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper4);
export default __webpack_public_path__ + "static/media/stepper4.15844275ba6aa347dabf828aa64e9883.svg";
export { ForwardRef as ReactComponent };